import React from "react";

const ComponentTitle = ({title}) => {
  return(
    <div className="lg:text-base md:text-sm text-white bg-blue-800 inline-block content-center font-bold px-2.5">
        {title} 
    </div>
  )
}

export default ComponentTitle